(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AccessDeniedV2Controller', AccessDeniedV2Controller);

    AccessDeniedV2Controller.$inject = ['$state', '$scope', '$rootScope', 'Auth'];

    function AccessDeniedV2Controller($state, $scope, $rootScope, Auth) {
        var vm = this;

        vm.goToPrevState = function () {
            var prev = $rootScope.fromState;
            if (prev && prev.name) {
                if ($rootScope.fromStateParams && $rootScope.fromStateParams.id)
                    $state.go(prev, {id: $rootScope.fromStateParams.id});
                else
                    $state.go(prev.name);
            } else {
                $state.go('home');
            }
        }

    }
})();
